import { render, staticRenderFns } from "./abColorIcon.vue?vue&type=template&id=26166bd7&"
import script from "./abColorIcon.vue?vue&type=script&lang=js&"
export * from "./abColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports